const techIconMap = {
  // Languages
  Python: 'python',
  JavaScript: 'javascript',
  TypeScript: 'typescript',
  Java: 'openjdk',
  JavaFX: 'openjdk',
  PHP: 'php',
  Go: 'go',
  Rust: 'rust',
  Ruby: 'ruby',
  'C++': 'cplusplus',
  'C#': 'csharp',
  Kotlin: 'kotlin',
  Swift: 'swift',

  // Frameworks & Libraries
  FastAPI: 'fastapi',
  Flask: 'flask',
  Django: 'django',
  React: 'react',
  'React Native': 'react',
  'Next.js': 'nextdotjs',
  'Node.js': 'nodedotjs',
  'Vue.js': 'vuedotjs',
  Angular: 'angular',
  'Spring Boot': 'springboot',
  'Spring Security': 'springboot',
  Laravel: 'laravel',
  'Tailwind CSS': 'tailwindcss',
  LangChain: 'langchain',
  LangGraph: 'langchain',
  TensorFlow: 'tensorflow',
  Keras: 'keras',
  'Scikit-learn': 'scikitlearn',
  PyTorch: 'pytorch',
  OpenCV: 'opencv',
  'Hugging Face': 'huggingface',
  Nginx: 'nginx',
  GraphQL: 'graphql',
  Streamlit: 'streamlit',
  Pandas: 'pandas',
  'Three.js': 'threedotjs',
  Gatsby: 'gatsby',
  'Styled Components': 'styledcomponents',
  Pytest: 'pytest',

  // AI & ML
  OpenAI: 'robotframework/white',
  Groq: 'fastify/white',
  'Deep Learning': 'tensorflow',
  NLP: 'spacy',
  LSTM: 'tensorflow',
  SVM: 'scikitlearn',
  RAG: 'langchain',
  UNet: 'tensorflow',
  EfficientNetB4: 'tensorflow',
  'AI/ML': 'tensorflow',

  // Databases
  PostgreSQL: 'postgresql',
  MySQL: 'mysql',
  MongoDB: 'mongodb',
  Redis: 'redis',
  SQLite: 'sqlite',
  Supabase: 'supabase',
  pgvector: 'postgresql',

  // DevOps / Cloud
  Docker: 'docker',
  Kubernetes: 'kubernetes',
  'GitHub Actions': 'githubactions',
  Linux: 'linux',
  Git: 'git',
  GitHub: 'github',
  AWS: 'amazonaws',
  'Amazon Web Services (AWS)': 'amazonaws',
  Azure: 'microsoftazure',
  'Google Cloud': 'googlecloud',
  Vercel: 'vercel',
  Netlify: 'netlify',
  Prometheus: 'prometheus',

  // Other
  Oracle: 'oracle',
  Odoo: 'odoo',
  Cisco: 'cisco',
  NVIDIA: 'nvidia',
  'REST API': 'json',
  'Data Visualization': 'plotly',
  'Time Series': 'clockify',
  'Signal Processing': 'scipy',
  Mojo: 'firebase',
};

export default techIconMap;

